import classNames from 'classnames';
import { Eye, EyeOff } from 'react-feather';
import { useTranslation } from 'react-i18next';

import { useMutation } from '../../Shared/api';
import { useNotifier } from '../../Shared/Notifier/NotificationProvider';
import { Campaign } from '../../Shared/types';
import { Toggle } from '../../Shared/UI/Toggle';
import { useRouter } from '../router';

export default function CampaignToggle({
  campaign,
}: {
  campaign: Campaign & {
    toggleable: boolean;
  };
}) {
  const { t } = useTranslation();
  const { routes } = useRouter();
  const notifier = useNotifier();

  const [toggleCampaign, { loading }] = useMutation(routes.toggle_campaign(campaign.id), {
    preserveScroll: true,
    onSuccess: () => {
      notifier.notify(
        !campaign.enabled ? t('backend:campaign_enabled') : t('backend:campaign_disabled'),
        !campaign.enabled ? Eye : EyeOff
      );
    },
  });

  return (
    <div className="inline-flex items-center space-x-4">
      <div className={classNames('font-medium', campaign.enabled ? 'text-emerald-600' : 'text-slate-500')}>
        {campaign.enabled ? t('backend:live') : t('backend:offline')}
      </div>
      <div className="z-20">
        <Toggle
          checked={campaign.enabled}
          onChange={() => toggleCampaign({ enabled: !campaign.enabled })}
          disabled={loading || !campaign.toggleable} />
      </div>
    </div>
  );
}
